const Main = () => import(/* webpackChunkName: "exoty" */ '@/modules/main/main.vue');
const EmptyRouterView = () => import(/* webpackChunkName: "exoty" */ '@/components/EmptyRouter.vue');
const ArenaSetting = () => import(/* webpackChunkName: "arena" */ './setting/view/Edit.vue');
const ArenaItemAdd = () => import(/* webpackChunkName: "arena" */ './item/view/Add.vue');
const ArenaItemClone = () => import(/* webpackChunkName: "arena" */ './item/view/Clone.vue');
const ArenaItemDetail = () => import(/* webpackChunkName: "arena" */ './item/view/Detail.vue');
const ArenaItemEdit = () => import(/* webpackChunkName: "arena" */ './item/view/Edit.vue');
const ArenaItemList = () => import(/* webpackChunkName: "arena" */ './item/view/Index.vue');
const ArenaItemMedal = () => import(/* webpackChunkName: "arena" */ './item/view/Medal.vue');
const ArenaMedalAdd = () => import(/* webpackChunkName: "arena" */ './medal/view/Add.vue');
const ArenaMedalEdit = () => import(/* webpackChunkName: "arena" */ './medal/view/Edit.vue');
const ArenaMedalList = () => import(/* webpackChunkName: "arena" */ './medal/view/Index.vue');
const ArenaTicketAdd = () => import(/* webpackChunkName: "arena" */ './ticket/view/Add.vue');
const ArenaTicketEdit = () => import(/* webpackChunkName: "arena" */ './ticket/view/Edit.vue');
const ArenaTicketList = () => import(/* webpackChunkName: "arena" */ './ticket/view/Index.vue');
const ArenaCycleList = () => import(/* webpackChunkName: "arena" */ './cycle/view/cycle.vue');
const ArenaCycleRank = () => import(/* webpackChunkName: "arena" */ './cycle/view/rank.vue');

export const ROUTE_NAME_ARENA = {
    SETTING: 'ArenaSetting',
    ITEM: {
        INDEX: 'ArenaItemList',
        ADD: 'ArenaItemAdd',
        EDIT: 'ArenaItemEdit',
        CLONE: 'ArenaItemClone',
        DETAIL: 'ArenaItemDetail',
        MEDAL: 'ArenaItemMedal'
    },
    CYCLE: {
        INDEX: 'ArenaCycleList',
        RANK: 'ArenaCycleRank'
    },
    MEDAL: {
        INDEX: 'ArenaMedalList',
        ADD: 'ArenaMedalAdd',
        EDIT: 'ArenaMedalEdit'
    },
    TICKET: {
        INDEX: 'ArenaTicketList',
        ADD: 'ArenaTicketAdd',
        EDIT: 'ArenaTicketEdit'
    }
};

export default [
    {
        path: '/app/:appId/arena/',
        name: 'Arena',
        component: Main,
        meta: { requiresAuth: true },
        children: [
            {
                path: 'setting',
                name: 'ArenaSetting',
                component: ArenaSetting,
                meta: { requiresAuth: true }
            },
            {
                path: 'item',
                name: 'ArenaItem',
                component: EmptyRouterView,
                children: [
                    {
                        path: '',
                        name: ROUTE_NAME_ARENA.ITEM.INDEX,
                        component: ArenaItemList,
                        meta: { requiresAuth: true }
                    },
                    {
                        path: 'add',
                        name: ROUTE_NAME_ARENA.ITEM.ADD,
                        component: ArenaItemAdd,
                        meta: { requiresAuth: true }
                    },
                    {
                        path: ':id/edit',
                        name: ROUTE_NAME_ARENA.ITEM.EDIT,
                        component: ArenaItemEdit,
                        meta: { requiresAuth: true }
                    },
                    {
                        path: ':id/clone',
                        name: ROUTE_NAME_ARENA.ITEM.CLONE,
                        component: ArenaItemClone,
                        meta: { requiresAuth: true }
                    },
                    {
                        path: ':id/detail',
                        name: ROUTE_NAME_ARENA.ITEM.DETAIL,
                        component: ArenaItemDetail,
                        meta: { requiresAuth: true }
                    },
                    {
                        path: ':id/medal',
                        name: ROUTE_NAME_ARENA.ITEM.MEDAL,
                        component: ArenaItemMedal,
                        meta: { requiresAuth: true }
                    }
                ]
            },
            {
                path: 'cycle',
                component: EmptyRouterView,
                children: [
                    {
                        path: '',
                        name: ROUTE_NAME_ARENA.CYCLE.INDEX,
                        component: ArenaCycleList,
                        meta: { requiresAuth: true }
                    },
                    {
                        path: ':cycleId/item/:arenaId/rank',
                        name: ROUTE_NAME_ARENA.CYCLE.RANK,
                        component: ArenaCycleRank,
                        meta: { requiresAuth: true }
                    }
                ]
            },
            {
                path: 'medal/',
                name: 'ArenaMedal',
                component: EmptyRouterView,
                children: [
                    {
                        path: '',
                        name: ROUTE_NAME_ARENA.MEDAL.INDEX,
                        component: ArenaMedalList,
                        meta: { requiresAuth: true }
                    },
                    {
                        path: 'add',
                        name: ROUTE_NAME_ARENA.MEDAL.ADD,
                        component: ArenaMedalAdd,
                        meta: { requiresAuth: true }
                    },
                    {
                        path: ':id/edit',
                        name: ROUTE_NAME_ARENA.MEDAL.EDIT,
                        component: ArenaMedalEdit,
                        meta: { requiresAuth: true }
                    }
                ]
            },
            {
                path: 'ticket/',
                name: 'ArenaTicket',
                component: EmptyRouterView,
                children: [
                    {
                        path: '',
                        name: ROUTE_NAME_ARENA.TICKET.INDEX,
                        component: ArenaTicketList,
                        meta: { requiresAuth: true }
                    },
                    {
                        path: 'add',
                        name: ROUTE_NAME_ARENA.TICKET.ADD,
                        component: ArenaTicketAdd,
                        meta: { requiresAuth: true }
                    },
                    {
                        path: ':type/edit',
                        name: ROUTE_NAME_ARENA.TICKET.EDIT,
                        component: ArenaTicketEdit,
                        meta: { requiresAuth: true }
                    }
                ]
            }
        ]
    }
];
